module.exports = __webpack_public_path__ + "static/laptop-911e5c6d8684887ff522670207141a5c.png";